import { render, staticRenderFns } from "./CountrySheet.vue?vue&type=template&id=0bd82a3e&scoped=true&"
import script from "./CountrySheet.vue?vue&type=script&lang=js&"
export * from "./CountrySheet.vue?vue&type=script&lang=js&"
import style0 from "./CountrySheet.vue?vue&type=style&index=0&id=0bd82a3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bd82a3e",
  null
  
)

export default component.exports